// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginPhone_loginContainer__QRfLw","loginContainers":"LoginPhone_loginContainers__HpGcr"};